import { policyPages } from "../../data/content";
import { MarketingPage } from "../blog/MarketingPage";

type PolicyPageProps = {
  policyId: keyof typeof policyPages;
};

export function PolicyPage({ policyId }: PolicyPageProps) {
  return <MarketingPage page={policyPages[policyId]} />;
}
